module.exports = __webpack_public_path__ + "static/img/schedulePic_new_2.37e8b87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/schedulePic_new_2.png
// module id = L1TH
// module chunks = 0